<!-- Button -->
<button *ngIf="menuItems.length > 0" data-cy="menuAdd" mat-icon-button [matMenuTriggerFor]="addActions">
  <span class="relative">

    <mat-icon [svgIcon]="'heroicons_outline:plus-circle'"></mat-icon>
    <span class="absolute right-0 bottom-0 w-2 h-2 rounded-full"></span>
  </span>
</button>

<mat-menu [xPosition]="'before'" #addActions="matMenu">
  <button *ngFor="let mi of menuItems" [attr.data-cy]="mi.dataCY" mat-menu-item (click)="mi.action()">
    <!-- <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon> -->
    <span>{{ mi.description }}</span>
  </button>
</mat-menu>